module.exports = __webpack_public_path__ + "img/profile-pic-casual.fc203a41.jpg";